import API from '@/api'
import defaultSetting from '@/settings'
import { changeFavicon } from '@/utils'
import router from '@/router' // 路由
import { getSchoolMark } from '@/utils/index'
const state = {
  showType: 'pc',
  currentRouterKey: 'Index',
  appConfig: {
    description: '',
    gongan_beian: '',
    ico: '',
    icp_beian: '',
    keywords: '',
    logo: '',
    remark: '',
    site: '',
    title: '',
    webstate: '',
    state: 1
  }
}
const mutations = {
  CHANGE_CURRENT_ROUTER_KEY: (state, key) => {
    state.currentRouterKey = key
  },
  SET_APP_CONFIG: (state, data) => {
    state.appConfig = data
    defaultSetting.title = data.title
    defaultSetting.side = data.site
  },
  CHANGE_SHOW_TYPE(state, type) {
    state.showType = type
  }
}

const actions = {
  getSysteamSetting({ commit }) {
    // 获取url中的参数

    API.SysteamSetting(getSchoolMark()).then(res => {
      if (+res.code === 200) {
        commit('SET_APP_CONFIG', res.data.list)
        //

        if (+res.data.list.state !== 1 && router.currentRoute.path !== '/404') {
          router.replace('/404')
        }

        // 设置 浏览器标题
        document.title = res.data.list.name
        //
        document.documentElement.style.setProperty('--theme-color', res.data.list.theme_color)
        // 设置 浏览器图标
        changeFavicon(res.data.list?.extra_content?.ico_image || '')
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
